import type React from "react";
import {
  DOCUMENT_MAX_BYTES,
  DOCUMENT_MAX_EDGE,
  DOCUMENT_QUALITY,
  isImageFile,
  resizeImageToFile,
} from "./fileSaver";

const PDF_EXT = /\.pdf$/i;

export const PORTAL_DOCUMENT_ACCEPT = "application/pdf,image/*";
export const PORTAL_CAMERA_ACCEPT = "image/*";

function isPdfFile(file: File): boolean {
  return file.type === "application/pdf" || PDF_EXT.test(file.name);
}

export async function pickPortalDocumentFile(
  event: React.ChangeEvent<HTMLInputElement>,
  onValidFile: (file: File) => void,
  onInvalidFile: () => void,
): Promise<void> {
  const selectedFile = event.target.files?.[0];
  if (!selectedFile) {
    event.target.value = "";
    return;
  }

  try {
    if (isPdfFile(selectedFile)) {
      onValidFile(selectedFile);
      return;
    }

    if (isImageFile(selectedFile)) {
      try {
        const resized = await resizeImageToFile(
          selectedFile,
          DOCUMENT_MAX_EDGE,
          DOCUMENT_MAX_EDGE,
          DOCUMENT_QUALITY,
          DOCUMENT_MAX_BYTES,
        );
        onValidFile(resized);
      } catch {
        onInvalidFile();
      }
      return;
    }

    onInvalidFile();
  } finally {
    event.target.value = "";
  }
}
